<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<div class="text-xs-center">
			<v-dialog v-model="modal" persistent width="1000">
				<v-card>
					<v-card-title class="headline accent" primary-title>
						Eksport ocen
					</v-card-title>

					<v-card-text>
						<v-form ref="form">
							<v-flex d-flex>
								<v-autocomplete label="Wybierz pole" :item-text="getFieldName" item-value="id"
									aria-label="field" v-model="selectedFieldId" :items="fields" :menu-props="{
										maxWidth: 650,
										minWidth: 650,
									}">
									<template v-slot:item="{ item }">
										<span :class="{
											'primary--text': item.generic,
											'font-weight-bold': isFieldExpandable(item),
											'font-italic': isTableField(item)
										}">
											{{ getFieldName(item) }}
										</span>
									</template>
								</v-autocomplete>
								<v-btn style="flex: none !important;" color="primary" @click="addAllFields">
									Dodaj wszystkie pola
								</v-btn>
								<v-btn style="flex: none !important;" color="primary" @click="resetFields">
									Resetuj
								</v-btn>
							</v-flex>
							<v-flex v-if="selectedFieldId">
								<v-divider />
								<v-container>
									{{ selectedFieldName }}
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn icon color="success" @click="acceptChosenField">
												<v-icon v-on="on" class="white-icon">done</v-icon>
											</v-btn>
										</template>
										<span>Dodaj</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn icon color="red" @click="cancelChosenField">
												<v-icon v-on="on" class="white-icon">close</v-icon>
											</v-btn>
										</template>
										<span>Usuń</span>
									</v-tooltip>
								</v-container>
								<v-divider />
							</v-flex>
							<export-field-list v-model="chosenFields" />
						</v-form>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue" @click="closeModal">
							Anuluj
						</v-btn>
						<v-btn color="primary" @click="exportData">
							Eksportuj
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</div>
	</div>
</template>

<script>
import { Api } from "@/api";
import { PublicContest } from "@/api/generated/PublicContest";
import { genericFormUtil } from "@/utils/genericFormUtil";
import { Files } from "@/utils/Files";
import { isExpandableFieldCode } from "@/utils/ExportFieldUtils";
import ExportFieldList from "@/view/logged/offer/components/ExportFieldList";

export default {
	name: "EvaluationExportModal",
	components: { ExportFieldList },
	mixins: [Files],

	data() {
		return {
			modal: false,
			contestId: this.$route.params.id,
			contestData: null,
			fields: [],
			selectedFieldId: null,
			chosenFields: [],
			parameters: null,
			booleanEvaluation: null,
			constantFields: [],
		};
	},

	computed: {
		selectedFieldName() {
            const field = this.fields.find(field => field.id === this.selectedFieldId);
            return this.getFieldName(field);
        }
	},

	methods: {
		getFieldName(item) {
			if (!item || !item.name) return 'Pole bez nazwy';
			return item.business === 'TABLE' ? item.name + ' (tabela)' : item.name;
		},
		isTableField(item) {
			return item && item.business === 'TABLE';
		},
		isFieldExpandable(item) {
			if (!item) return false;
			const { code } = item;
			return isExpandableFieldCode(code);
		},

		acceptChosenField() {
			let field = this.fields.find(field => {
				return field.id === this.selectedFieldId;
			});
			this.chosenFields.push(JSON.parse(JSON.stringify(field)));
			this.selectedFieldId = null;
		},

		cancelChosenField() {
			this.selectedFieldId = null;
		},

		exportData() {
			PublicContest.postEvaluationExport(this, {
				fields: this.chosenFields,
				offerCodes: this.searchParams.offerCodes,
			},
				success => {
					let filename = "eksport_ocen.xlsx";
					this.$messagesBus.$emit("success", "Eksport danych z tabeli wykonano do pliku " + filename,
						success);
					Files.methods.downloadBlobResponse(success, filename);
				},
				error => this.$messagesBus.$emit("error", "Eksport nieudany", error),
				{
					responseType: "blob",
				}
			);
			this.closeModal();
		},

		closeModal() {
			this.modal = false;
		},

		addAllFields() {
			this.resetFields();
			this.chosenFields.push(...this.fields);
		},

		resetFields() {
			this.selectedFieldId = null;
			this.chosenFields.splice(0, this.chosenFields.length);
		},

		async openModal(searchParams, expertEvaluationsNumber, contestId = this.contestId) {
			this.contestId = contestId;
			await this.loadGenericSchema();
			await this.loadRatingSettings();
			this.modal = true;
			this.searchParams = { offerCodes: searchParams };
			this.initializeFields(expertEvaluationsNumber);
		},

		async initializeFields(expertEvaluationsNumber) {
			await this.loadConstantFields();

			const schemaTypes = [
				'GENERAL', 'FORMAL', 'SUBSTANTIVE', 'EXPERT',
				'AGENCY', 'COLLABORATION', 'COMMITTEE', 'CONFERENCE', 'FINAL', 'TEAM'
			];

			const constantFieldsBySchema = {};
			schemaTypes.forEach(schema => {
				constantFieldsBySchema[schema] = this.constantFields.filter(field => field.schema === schema);
			});

			const genericFieldsBySchema = {};
			schemaTypes.forEach(schema => {
				genericFieldsBySchema[schema] = [];
			});

			if (this.contestData.formalEvaluationSchema) {
				genericFieldsBySchema['FORMAL'] = genericFormUtil.getListOfAllFieldsWithPrefixName(
					genericFormUtil.decodeSchema(this.contestData.formalEvaluationSchema),
					"FORMAL"
				);
				genericFieldsBySchema['FORMAL'].forEach(field => field.schema = 'FORMAL');
			}

			if (this.contestData.substantiveEvaluationSchema) {
				genericFieldsBySchema['SUBSTANTIVE'] = genericFormUtil.getListOfAllFieldsWithPrefixName(
					genericFormUtil.decodeSchema(this.contestData.substantiveEvaluationSchema),
					"SUBSTANTIVE"
				);
				genericFieldsBySchema['SUBSTANTIVE'].forEach(field => field.schema = 'SUBSTANTIVE');
			}

			if (this.contestData.expertEvaluationSchema && expertEvaluationsNumber > 0) {
				genericFieldsBySchema['EXPERT'] = genericFormUtil.getListOfAllFieldsWithPrefixName(
					genericFormUtil.decodeSchema(this.contestData.expertEvaluationSchema),
					"EXPERT"
				);
				genericFieldsBySchema['EXPERT'].forEach(field => field.schema = 'EXPERT');
			}

			if (this.contestData.agencyEvaluationSchema) {
				genericFieldsBySchema['AGENCY'] = genericFormUtil.getListOfAllFieldsWithPrefixName(
					genericFormUtil.decodeSchema(this.contestData.agencyEvaluationSchema),
					"AGENCY"
				);
				genericFieldsBySchema['AGENCY'].forEach(field => field.schema = 'AGENCY');
			}

			if (this.contestData.finalEvaluationSchema) {
				genericFieldsBySchema['FINAL'] = genericFormUtil.getListOfAllFieldsWithPrefixName(
					genericFormUtil.decodeSchema(this.contestData.finalEvaluationSchema),
					"FINAL"
				);
				genericFieldsBySchema['FINAL'].forEach(field => field.schema = 'FINAL');
			}

			if (this.contestData.collaborationEvaluationSchema) {
				genericFieldsBySchema['COLLABORATION'] = genericFormUtil.getListOfAllFieldsWithPrefixName(
					genericFormUtil.decodeSchema(this.contestData.collaborationEvaluationSchema),
					"COLLABORATION"
				);
				genericFieldsBySchema['COLLABORATION'].forEach(field => field.schema = 'COLLABORATION');
			}

			this.fields = [];

			schemaTypes.forEach(schema => {
				this.fields.push(...constantFieldsBySchema[schema]);
				this.fields.push(...genericFieldsBySchema[schema]);
			});
		},

		async loadRatingSettings() {
			await Api.syncGet(this, "/substantive-evaluation/configuration?contestId=" + this.contestId,
				success => {
					this.booleanEvaluation = success.booleanEvaluation;
					this.parameters = success.parameters;
				},
				error => {
					this.$messagesBus.$emit("error", "Nie udało się wczytać konfiguracji oceny merytorycznej", error);
				});
		},

		async loadGenericSchema() {
			await Api.syncGet(this, "/public-contest/data-required-to-export-evaluations?contestId=" + this.contestId,
				success => {
					this.contestData = success;
					this.contestData.substantiveEvaluationSchema = this.contestData.individualEvaluationSchema;
				},
				error => {
					this.$messagesBus.$emit("error", "Nie udało się wczytać wszystkich pól do eksportu", error);
				});
		},

		async loadConstantFields() {
			await Api.syncGet(this, "/public-contest/evaluation-constant-fields?contestId=" + this.contestId,
				success => {
					this.constantFields = success;
				},
				error => {
					this.$messagesBus.$emit("error", "Nie udało się wczytać wszystkich pól do eksportu", error);
				});
		}
	},
};
</script>

<style scoped>
.v-icon {
	color: #fff !important;
}
</style>
